<template>
	<flickity ref="flickity" :options="flickityOptions" class="resto-carousel">
		<slot></slot>
	</flickity>
</template>

<script>
	import FlickityimagesLoaded from 'flickity-imagesloaded';
	import Flickity from 'vue-flickity';

	export default {

		components: {
			Flickity,
		},

		data () {
			return {
				flickityOptions: {
					imagesLoaded: true,
					wrapAround: true,
					adaptiveHeight: true,
					percentPosition: false,
					autoPlay: 4000,
					cellSelector: '.resto-carousel-cell',
					prevNextButtons: false,
					pageDots: true,
					dragThreshold: 10,
					contain: false,
				}
			}
		},

		mounted() {
			let flicker = this.$refs.flickity.data('flickity')
			this.$el.addEventListener('mouseleave', function(e) {
				flicker.playPlayer()
			});
			let isScrolling
			let flick = this.$refs.flickity
			window.addEventListener('scroll', function ( event ) {
				flick.disableDrag()
				window.clearTimeout( isScrolling )
				isScrolling = setTimeout(function() {
					flick.enableDrag()
				}, 100)
			}, false)
		},

	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/RestoDetailsCarousel.vue